import { FormsMultilineInput, RadioGroup, RadioItem, Spinner } from '@platform/components';
import { AssignmentDeclinedReason, SimplifiedUserRole } from '@platform/client/schemas';
import { Control, FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type MatchDecliningContentProps = {
  isSaving: boolean;
  userAccountType: SimplifiedUserRole;
  register: UseFormRegister<UpdateDiscoveryCallFormData>;
  control: Control<UpdateDiscoveryCallFormData>;
  setValue: UseFormSetValue<UpdateDiscoveryCallFormData>;
  selectedReason: AssignmentDeclinedReason | undefined;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

const proDecliningReasons: RadioItem[] = [
  {
    value: AssignmentDeclinedReason.choosing_different_org,
    title: "I'm choosing a different organization",
  },
  {
    value: AssignmentDeclinedReason.wrong_skills,
    title: "I don't have the right skills",
  },
  {
    value: AssignmentDeclinedReason.timezone_or_availability,
    title: 'Timezone or availability reasons',
  },
  {
    value: AssignmentDeclinedReason.other,
    title: 'Other',
  },
];

const orgRepDecliningReasons: RadioItem[] = [
  {
    value: AssignmentDeclinedReason.choosing_different_org,
    title: "I'm choosing a different Experteer",
  },
  {
    value: AssignmentDeclinedReason.wrong_skills,
    title: "They don't have the right skills",
  },
  {
    value: AssignmentDeclinedReason.project_no_longer_fits,
    title: 'This project no longer fits my needs',
  },
  {
    value: AssignmentDeclinedReason.timezone_or_availability,
    title: 'Timezone or availability reasons',
  },
  {
    value: AssignmentDeclinedReason.other,
    title: 'Other',
  },
];

export const MatchDecliningContent = (props: MatchDecliningContentProps) => {
  const { selectedReason, isSaving, userAccountType } = {
    ...props,
  };

  return (
    <div className='flex flex-col gap-8 md:mt-8 items-stretch md:w-[500px]'>
      {isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-xl'>Can you tell us why this wasn't a good fit?</div>
          <div className='mt-4'>
            {/* TODO: Handle the org rep case */}
            <RadioGroup
              name='decline-reason'
              aria-label='decline-reason'
              items={
                userAccountType === SimplifiedUserRole.PROFESSIONAL ?
                  proDecliningReasons
                : orgRepDecliningReasons
              }
              onChange={(value) => {
                props.setValue('reason', value as AssignmentDeclinedReason, {
                  shouldValidate: true,
                });
              }}
              register={() =>
                props.register('reason', { required: 'Select one option to continue' })
              }
              defaultValue={props.selectedReason}
              error={props.formState.errors.reason?.message}
            />
          </div>
          {selectedReason === AssignmentDeclinedReason.other && (
            <div className='mt-4'>
              <div className='text-sm'>Additional Details</div>
              <FormsMultilineInput
                control={props.control}
                name='declineReasonDetails'
                characterCount={500}
                placeholder="Tell us more about why this wasn't a good fit..."
                rules={{ required: `To continue, tell us more about why this wasn't a good fit.` }}
                formsError={props.formState.errors.declineReasonDetails}
              />
            </div>
          )}
        </>
      }
    </div>
  );
};
